import React from 'react';
import HeaderOne from '../Components/Header/HeaderOne';
import CarHireBanner from '../Components/CarHire/CarHireBanner';
import CarHireBooking from '../Components/CarHire/CarHireBooking';
import CarHireOffers from '../Components/CarHire/CarHireOffers';
import CarHireDestinations from '../Components/CarHire/CarHireDestinations';
import CarHireServices from '../Components/CarHire/CarHireServices';
import FooterOne from '../Components/Footer/FooterOne';
import ScrollToTop from '../Components/ScrollToTop';

function HomeSix() {
    return (
        <div>
            <HeaderOne />
            <CarHireBanner />
            <CarHireBooking />
            <CarHireOffers />
            <CarHireDestinations />
            <CarHireServices />
            <FooterOne />
            <ScrollToTop />
        </div>
    );
}

export default HomeSix;
